import { jsx as _jsx } from "react/jsx-runtime";
import { CardMFEProvider } from "@aviv-classified-card/card/full";
import { Carousel as GeminiCarousel } from "@gemini/ui";
import { useSimilarCarousel } from "./useSimilarCarousel";
import { useEffect } from "react";
import { useEnv, useBrand } from "@/contexts/cdpConfig";
import { useI18n } from "@/shared/hooks";
import { SimilarContainer } from "./ui";
import { SimilarCard } from "./SimilarCard";
import { useTrackingSimilarListingLoad } from "@/hooks/tracking/useTrackingSimilarListingLoad";
import { useIsIntersecting, useTestId } from "@/hooks";
import { useConfirmationPage } from "@/contexts/confirmPage";
import { useLocale } from "@aviv-unified-frontend/runtime/i18n";
export const SimilarListingsCarousel = ({ display, similarListings, similars, }) => {
    const sendSimilarListingTracking = useTrackingSimilarListingLoad(similarListings);
    const { isIntersecting } = useIsIntersecting({
        elementId: "similarListings",
        triggerOnce: true,
        rootMargin: "0px",
    });
    const { nbItemsDisplayed, cardWidth } = useSimilarCarousel();
    const testId = useTestId("SimilarListingsCarousel");
    const brand = useBrand();
    const env = useEnv();
    const { language } = useLocale();
    const { t } = useI18n();
    const isCarouselDisplayed = (similarListings === null || similarListings === void 0 ? void 0 : similarListings.length) > nbItemsDisplayed;
    const { showConfirm } = useConfirmationPage();
    const trackingMediumValue = showConfirm
        ? "classified_detail_lead_confirmation_similars_bottom_classified_detail"
        : "classified_detail_similars_bottom_classified_detail";
    useEffect(() => {
        if (display && isIntersecting)
            sendSimilarListingTracking();
    }, [display, isIntersecting, sendSimilarListingTracking]);
    if (!display)
        return null;
    return (_jsx(CardMFEProvider, { cards: similars, brand: brand === "immoweltat" ? "immowelt" : brand, locale: language, stage: env, formatBreakpoints: { vertical: "base" }, fixedCardHeight: { active: true, keyFactsWidth: `${cardWidth - 32}` }, trackingMedium: trackingMediumValue, children: _jsx(SimilarContainer, { testId: testId, children: _jsx(GeminiCarousel, { itemsPerView: nbItemsDisplayed, arrowPosition: "outside", title: t("similar_listings.title"), itemsFixedWidth: cardWidth, items: similarListings.map((item) => ({
                    id: item.id,
                    item: (_jsx(SimilarCard, { item: item, width: `${cardWidth}px` }, item.id)),
                })), step: "grouped", hasDots: isCarouselDisplayed, dotsPosition: "outside" }) }) }));
};
